import React, { useEffect, useState } from "react";
import "../styles/Header.css";
import { auth } from "../backend/firebase";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";

const Header = ({ hideSearch = false, heading = null }) => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  return (
    <div className="header-main-container">
      {/* LEFT — LOGO */}
      <div className="header-left" onClick={() => navigate("/")}>
        <span className="logo-head">Seta</span>
      </div>

      {/* CENTER — PROFILE PIC + HEADING */}
      <div className="header-center">
        {user?.uid && (
          <div className="profile-wrapper-header">
            <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
              <img
                src={user.photoURL}
                alt="Profile"
                className="profile-img-header"
              />
              {heading && (
                <span className="logo-subhead">/{heading.toLowerCase()}</span>
              )}
            </div>

            {/* DROPDOWN MENU */}
            <div className="dropdown-menu-header">
              <div
                className="dropdown-item-header"
                onClick={() => navigate(`/user/${user.uid}`)}
              >
                My Profile
              </div>
              <div
                className="dropdown-item-header"
                onClick={() => navigate(`/collections/${user.uid}`)}
              >
                Collections
              </div>
              <div
                className="dropdown-item-header"
                onClick={() => navigate(`/profile-actions/${user.uid}`)}
              >
                Profile Actions
              </div>
              <div
                className="dropdown-item-header"
                onClick={() => navigate(`/request/${user.uid}`)}
              >
                Watch My Pull Request
              </div>
              <div
                className="dropdown-item-header"
                onClick={() => navigate(`/add/${user.uid}`)}
              >
                Release Data
              </div>
              <div
                className="dropdown-item-logout"
                onClick={() => auth.signOut()}
              >
                Leave
              </div>

              <div className="profile-info-dropdown">
                <img
                  src={user.photoURL}
                  alt="Profile"
                  className="dropdown-profile-pic"
                />
                <div className="profile-text-container">
                  <div className="profile-name-dropdown">
                    {user.displayName || "User"}
                  </div>
                  <div className="profile-email-dropdown">{user.email}</div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* RIGHT — SEARCH */}
      {!hideSearch && (
        <div className="header-right" onClick={() => navigate("/search")}>
          <div className="search-container-header">
            <span className="search-text">Search</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
